// This script is used for the account details page, updating customer details and sending a password reset email

const updateCustomerUrl = "https://australia-southeast1-scotchsoda-website.cloudfunctions.net/updateCustomer";

const gcpHeaders = {
  shop: Shopify.shop?.replace(".myshopify.com", ""),
  "Content-Type": "application/json",
};

// Update customer details
window.update = async function update(updateData) {
  try {
    const response = await fetch(updateCustomerUrl, {
      method: 'POST',
      headers: {
        ...gcpHeaders,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updateData),
    });

    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.errors || errorData.message || "An unknown error occurred");
    }

    const data = await response.json();

    return {
      error: false,
      message: null,
      data: data,
    };
  } catch (error) {
    return {
      error: true,
      message: error.message,
      data: null,
    };
  }
};

// Password reset JS starts here
const CHANGE_PASSWORD = `mutation ChangePassword($email: String!) {
  customerRecover(email: $email) {
    customerUserErrors {
      code
      field
      message
    }
  }
}`;

let baseURL = `https://${Shopify.shop}/api/2024-01/graphql.json`;

// Sends a password reset email to customers email
window.changePassword = async function changePassword(email) {
  if (!email.length) return false;

  try {
    const response = await fetch(baseURL, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "X-Shopify-Storefront-Access-Token": storeFrontAccessToken(),
      },
      body: JSON.stringify({
        query: CHANGE_PASSWORD,
        variables: { email },
      }),
    });

    if (!response.ok) {
      console.error(`HTTP error! Status: ${response.status}`);
      return false;
    }

    const responseData = await response.json();
    const { data, errors } = responseData;

    if (errors) return false;

    const changed = !data?.customerRecover?.customerUserErrors?.length;
    if (!changed) return false;

    return true;
  } catch (error) {
    console.error(error);
    return false;
  }
};
